export default __webpack_public_path__ + "static/media/feature--hero.3648b16e.png";